import { NumberFormatter as NF } from "~/common/utils/NumberFormatter";
import Parameter from "../../../../common/components/Parameter";
import { type PriceData } from "~/domains/pricing/types/PriceData";
import * as PriceUtils from "../../../../utils/PriceUtils";
import { NBSP } from "../../../../utils/constants";
import { useTranslation } from "react-i18next";

interface CommonProps {
  className?: string;
}

interface QuantitySubtotalProps extends CommonProps {
  quantity?: number;
}
export const QuantitySubtotal = ({ className, quantity = 0 }: QuantitySubtotalProps) => {
  const { t } = useTranslation();

  return (
    <Parameter
      className={className}
      data-test-id={"product-entry-total-quantity"}
      label={t("cartPage.table.item", { count: quantity })}
    >
      {NF.getDefaultFormatter().format(quantity)}
    </Parameter>
  );
};

interface DeliverySubtotalrops extends CommonProps {
  isSubscription?: boolean;
  quantity?: number;
}
export const DeliverySubtotal = ({ className, quantity = 0, isSubscription }: DeliverySubtotalrops) => {
  const { t } = useTranslation();

  return (
    <Parameter
      className={className}
      data-test-id={"product-entry-delivery-amount"}
      label={t("cartPage.table.delivery", { count: quantity })}
    >
      {isSubscription ? "-" : NF.getDefaultFormatter().format(quantity)}
    </Parameter>
  );
};

interface PriceSubtotalrops extends CommonProps {
  isSubscription?: boolean;
  price: PriceData;
  hideLabel?: boolean;
  hasSurcharge?: boolean;
}
export const PriceSubtotal = ({ className, price, hideLabel, hasSurcharge }: PriceSubtotalrops) => {
  const { t } = useTranslation();
  const disableWS = window.SCHA.config.disableAllWS;
  hasSurcharge = !!(hasSurcharge && price && price.value > 0);

  return (
    <Parameter
      className={className}
      data-test-id={"product-entry-total-price"}
      label={hideLabel ? NBSP : t("cartPage.table.subtotal")}
    >
      <span className={"f-bold"}>
        {disableWS ? "-" : PriceUtils.text(price, "-")}
        {!disableWS && hasSurcharge && "*"}
      </span>
    </Parameter>
  );
};

export const TargetPriceSubtotal = ({ className, price }: PriceSubtotalrops) => {
  const { t } = useTranslation();

  return (
    <Parameter
      className={className}
      data-test-id={"product-entry-target-total-price"}
      label={t("activeQuotePage.table.targetSubtotal")}
    >
      <span className={"f-bold"}>{PriceUtils.text(price, "-")}</span>
    </Parameter>
  );
};
